import styled from 'styled-components'

const Layout = {
  Container: styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
    position: absolute;
    width: 100%;
    padding-top: 0px;
    overflow-y: scroll;
  `,

  // responsive main container - min-width only on desktop
  Main: styled.main`
    overflow-y: scroll;
    height: 100%;
    -ms-overflow-style: none; /* for Internet Explorer, Edge */
    scrollbar-width: none; /* for Firefox */
    width: 100%;
    
    @media (max-width: 768px) {
      min-width: unset;
      width: 100%;
    }
    
    &::-webkit-scrollbar {
      display: none; /* for Chrome, Safari, and Opera */
      `,
}

export default Layout
